module.exports = __webpack_public_path__ + "static/media/question.f2d40903.svg";